import { createAction, props } from '@ngrx/store';
import { PageDto } from '../api/core';
import { FilterParams } from '../router';
import { RouterTypeActionTypes } from './router-types.models';

export const loading = createAction(RouterTypeActionTypes.LOADING);
export const loadingDone = createAction(RouterTypeActionTypes.LOADING_DONE);
export const loadRouterTypes = createAction(RouterTypeActionTypes.LOAD_ROUTER_TYPES);
export const loadedRouterTypes = createAction(RouterTypeActionTypes.LOADED_ROUTER_TYPES, props<{ data: PageDto }>());
